import { Chart } from 'chart.js'
import React, { useContext, useEffect, useRef } from 'react'
import { AppContext } from '../../../../../contexts/AppContext'
import { createPanelProductionChart } from './createPanelProductionChart'

interface Props {
	chartData: { value: number; date: string }[]
}

const PanelProductionChart = ({ chartData }: Props) => {
	const chartElement = useRef<HTMLCanvasElement>(null)
	const chart = useRef<Chart>()
	const { isDarkMode } = useContext(AppContext)

	useEffect(() => {
		const initChart = () => {
			if (chartElement.current) {
				if (chart.current) {
					chart.current.destroy()
				}
				chart.current = createPanelProductionChart(chartElement.current, chartData, isDarkMode)
			}
		}

		initChart()

		return () => {
			if (chart.current) {
				chart.current.destroy()
				chart.current = undefined
			}
		}
	}, [chartData, isDarkMode, chartElement])

	return <canvas ref={chartElement}></canvas>
}

export default PanelProductionChart
